<template>
  <div>
    <vue-good-table
      :rows="articles"
      :columns="tableColumns"
      @on-row-click="click"
      styleClass="vgt-table"
      :sort-options="{
        enabled: false,
      }"
    >
      <template v-slot:table-row="props">

        <span v-if="props.column.field == 'title'">
          <div style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">

          <icon
            v-if="inFuture(props.row.publishedAt)"
            class="mx-1"
            icon="delay" />
            <span>
              {{ props.row.title }}
            </span>
          </div>
        </span>
        <span v-if="props.column.field === 'content-type'">
          <span :style="`color: ${props.row.contentType.color};font-weight: 100;letter-spacing: -.3px;font-size: 11px;text-transform: uppercase;`">
            {{ props.row.contentType.name }}
            <!-- <icon
              v-tooltip="props.row.contentType.name"
              icon="article"
              class="mr-1"
            /> -->
          </span>
        </span>
        <span v-if="props.column.field == 'analysts'">
          <div class="d-flex" style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
            <div
              v-for="analyst in reverse([props.row.leadAnalyst, props.row.secondaryAnalyst, ...props.row.contributors].filter(k => !!k))"
              :key="analyst.name"
              class="article__analyst"
              style="width: 24px;height: 24px;"
            >
              <img
                v-if="analyst"
                v-tooltip.top="analyst.name"
                :src="analyst.picture.round"
                class="rounded-circle img-circle-bg border-white article__analyst__img"
                width="24"
              >
            </div>
          </div>
        </span>
        <span v-if="props.column.field == 'provider'">
          <img
            v-tooltip.top="props.row.channel.name"
            height="24"
            class="mr-1"
            :src="props.row.channel.logo"
          >
        </span>
        <span v-if="props.column.field == 'published'">
          <span
            v-if="props.row.publishedAt"
            v-date="{ date: props.row.publishedAt, format: $settings.dateTimeFormat, isIso: true }"
            style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
          />
        </span>
        <span v-if="props.column.field === 'menu'">
          <dropdown
            alignment="right"
            trigger="click"
            class="no-chev"
            @click.native.stop
          >
            <button
              slot="trigger"
              v-if="showDraftEdit(props) || showArticleEdit(props) || showAlerts(props) || showDelete(props) || showRestore(props)"
              class="btn btn-link mr-3 no-chev"
            >
              <icon icon="more-vertical" />
            </button>

            <dropdown-option
                v-if='canRepublish'
                :href="$router.resolve({ name: 'articles.republish', params: { articleId: props.row.id } }).href"
                style='text-decoration: none;margin: 2px;'>
                <icon icon='edit' /> Republish
            </dropdown-option>

            <dropdown-option
                :href="$router.resolve({ name: 'articles.edit', params: { articleId: props.row.id } }).href"
                style="text-decoration: none;margin: 2px;"
            >
                <icon icon="edit" /> Edit
            </dropdown-option>
            <dropdown-option
                style="text-decoration: none;"
                href="javascript:;"
                @click.native="$emit('show-alerts', value(props.row).id)"
            >
                <icon icon="alerts" /> Alerts
            </dropdown-option>
            <dropdown-option v-if="showDelete(props)"
                style="text-decoration: none;"
                href="javascript:;"
                @click.native="$emit('delete', (props.row))"
            >
                <icon icon="delete" /> Delete
            </dropdown-option>
            <dropdown-option v-if="showRestore(props)"
                v-tooltip.top="'Restore'"
                href="javascript:;"
                @click.native="restore(props.row)"
            >
                <i class="sl-arrow-up-circle" /> Restore
            </dropdown-option>
          </dropdown>
        </span>
      </template>
    </vue-good-table>

    <pagination
      :data="pagination"
      :disabled="isLoading"
      @change-page="(p) => $emit('change-page', p)"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { VueGoodTable } from 'vue-good-table'
import Date from '@/directives/date'
import mixin from './Mixin'
import moment from 'moment'
import Dropdown from '@/components/Dropdown/Dropdown'
import DropdownOption from '@/components/Dropdown/DropdownOption'

export default {
  mixins: [mixin],
  directives: {
    Date,
  },
  components: {
    Pagination,
    Dropdown,
    DropdownOption,
    VueGoodTable,
  },
  props: {
    value: {
      required: false,
      type: Function,
      default (v) {
        return v
      },
    },
    articles: {
      type: Array,
      required: true,
    },
    pagination: {
      type: Object,
      required: false,
      default: null,
    },
    isDraftsList: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableColumns: [
        {field: 'title', label: 'Title', width: '50%'},
        {field: 'content-type', label: 'Content Type', width: '100px'},
        {field: 'analysts', label: 'Analysts', width: '100px'},
        {field: 'provider', label: 'Provider', width: '100px'},
        {
          field: this.isDraftsList ? 'updated' : 'published',
          label: this.isDraftsList ? 'Last Updated At': 'Published At',
          width: '100px',
        },
        {field: 'menu', width: '1px'},
      ]
    }

  },
  computed: {
    canRepublish() {
      return this.$login.isEditor()
    }
  },
  methods: {
    click ({row}) {
      if (row.latest_revision) {
        this.$router.push({
          name: 'articles.draft',
          params: {
            draftId: row.id,
          },
        })
      } else {
        this.$router.push({
          name: 'articles.view',
          params: {
            articleId: row.id,
          },
        })
      }
    },
    inFuture(date) {
      return moment(date).isAfter(moment())
    },
    reverse (analysts) {
      return [...analysts].reverse()
    },
    showDraftEdit (scope) {
      return this.isDraftsList && (this.$login.can('article-drafts.update') || this.$login.can('article-drafts.update.mine')) && (this.value(scope.row)._id !== null && this.value(scope.row)._id !== undefined)
    },
    showArticleEdit () {
      return !this.isDraftsList && this.$login.can('articles.update')
    },
    showAlerts (scope) {
      this.$login.can('alerts.view') && this.value(scope.row).deleted_at === null
    },
    showDelete (scope) {
      return (this.isDraftsList && (this.$login.can('article-drafts.delete') || this.$login.can('article-drafts.delete.mine')))
        || (!this.isDraftsList && this.$login.can('articles.delete'))
        && (this.value(scope.row).deleted_at === undefined || this.value(scope.row).deleted_at === null)
    },
    showRestore (scope) {
      return this.$login.can('articles.delete') && this.value(scope.row).deleted_at !== undefined && this.value(scope.row).deleted_at !== null
    },

    replaceCdn(s) {
      return s.replace('s3-eu-west-1.amazonaws.com/exotix-cdn/', 'cdn.tellimer.com/')
    },
  },
}
</script>

<style lang="scss">
</style>


